// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1YWPz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2h-Es"};